import React, { useEffect, useRef, useState } from 'react';
import { ChevronDownIcon, MenuIcon, PhoneIcon, MapPinIcon, XIcon } from 'lucide-react';
import { CATEGORIES, CONTACT, IMAGES, LINKS, SECONDARY_CATALOG_LINKS } from '../data/site';
const NAV = [{
  name: 'Workshops',
  href: LINKS.workshops
}, {
  name: 'Custom Fabrication',
  href: LINKS.fabrication
}, {
  name: 'Our Story',
  href: LINKS.story
}, {
  name: 'Contact',
  href: LINKS.contact
}];
const SHOP_MENU = [...CATEGORIES.map(c => ({
  name: c.name,
  href: c.href
})), {
  name: 'ECKOLD Machines',
  href: LINKS.eckold
}, ...SECONDARY_CATALOG_LINKS, {
  name: 'Shop All Tools',
  href: LINKS.shopAll
}];
export function Header() {
  const [shopOpen, setShopOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const shopWrapRef = useRef<HTMLDivElement>(null);
  const shopButtonRef = useRef<HTMLButtonElement>(null);
  const mobileButtonRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!shopOpen && !mobileOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        if (mobileOpen) mobileButtonRef.current?.focus();else shopButtonRef.current?.focus();
        setShopOpen(false);
        setMobileOpen(false);
      }
    };
    const onClick = (e: MouseEvent) => {
      if (shopWrapRef.current && !shopWrapRef.current.contains(e.target as Node)) setShopOpen(false);
    };
    document.addEventListener('keydown', onKey);
    document.addEventListener('mousedown', onClick);
    return () => {
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('mousedown', onClick);
    };
  }, [shopOpen, mobileOpen]);
  return <header className="relative z-40 bg-cream" data-id="element-134" data-mp="35j6el0fg4p0u">
      <div className="bg-charcoal text-steel-200" data-id="element-135" data-mp="30lehlrzy2cps">
        <div className="mx-auto flex max-w-[1240px] items-center justify-between gap-4 px-5 py-2 text-[12px] tracking-[0.06em] sm:px-8" data-id="element-136" data-mp="1wfqgqe5ogye">
          <p className="flex items-center gap-2" data-id="element-137" data-mp="3ta2bgbyreaey">
            <MapPinIcon aria-hidden="true" className="h-3.5 w-3.5 text-fred" data-id="element-138" data-mp="3t9afh0192ao5" />
            <span data-id="element-139" data-mp="1recy5okxj9o7">Mt. Clemens, Michigan</span>
          </p>
          <a href={CONTACT.phoneHref} className="flex min-h-[36px] items-center gap-2 font-medium text-white transition-colors duration-150 ease-out hover:text-fred" data-id="element-140" data-mp="1wcxn2ruqe6xc">
            <PhoneIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-141" data-mp="1mm301l9nv3au" />
            <span data-id="element-142" data-mp="18n3e4ldj92id">{CONTACT.phoneLabel}</span>
          </a>
        </div>
      </div>

      <div className="border-b border-steel-200" data-id="element-143" data-mp="18p69lkxgfnuh">
        <div className="mx-auto flex max-w-[1240px] items-center justify-between gap-6 px-5 py-4 sm:px-8" data-id="element-144" data-mp="1cpq8asxoeziq">
          <a href="/" className="flex shrink-0 items-center" aria-label="Fournier Enterprises home" data-id="element-145" data-mp="yq7df1tvlkod">
            <img src={IMAGES.logo} width={400} height={259} alt="Fournier Enterprises" className="h-[64px] w-auto sm:h-[72px] mix-blend-multiply" data-id="element-146" data-mp="13os1y3zrmfwz" />
          </a>

          <nav aria-label="Primary" className="hidden items-center gap-1 lg:flex" data-id="element-147" data-mp="2xznjhvsxh5bw">
            <div ref={shopWrapRef} className="relative" data-id="element-148" data-mp="mck4ctzocsou">
              <button type="button" ref={shopButtonRef} aria-controls="shop-menu" aria-expanded={shopOpen} aria-haspopup="true" onClick={() => setShopOpen(v => !v)} className="flex min-h-[44px] items-center gap-1.5 px-3 font-display text-[19px] font-semibold uppercase tracking-[0.05em] text-charcoal transition-colors duration-150 ease-out hover:text-fred" data-id="element-149" data-mp="hgmo0noevmc2">
                Shop Tools
                <ChevronDownIcon aria-hidden="true" className={`h-4 w-4 transition-transform duration-150 ease-out ${shopOpen ? 'rotate-180' : ''}`} data-id="element-150" data-mp="1f20q58sshbc3" />
              </button>
              {shopOpen && <div id="shop-menu" className="absolute left-0 top-full z-50 w-[300px] border border-steel-200 bg-white py-2 shadow-[0_18px_40px_-24px_rgba(25,27,29,0.5)]" data-id="element-151" data-mp="3bvvlc58x0zz3">
                  <ul data-id="element-152" data-mp="2311gfuwa27lu">
                    {SHOP_MENU.map(item => <li key={item.name} data-id="element-153" data-mp="27w71yslrpk9e">
                        <a href={item.href} className="flex min-h-[44px] items-center px-4 py-2 text-[14px] text-ink transition-colors duration-150 ease-out hover:bg-cream hover:text-fred" data-id="element-154" data-mp="2cx4hexfe8077">
                          {item.name}
                        </a>
                      </li>)}
                  </ul>
                </div>}
            </div>

            {NAV.map(item => <a key={item.name} href={item.href} className="flex min-h-[44px] items-center px-3 font-display text-[19px] uppercase tracking-[0.05em] text-charcoal transition-colors duration-150 ease-out hover:text-fred" data-id="element-155" data-mp="1xzkfy0hpgn5s">
                {item.name}
              </a>)}

            <a href={LINKS.shopAll} className="ml-3 flex min-h-[44px] items-center bg-fred px-5 font-display text-[18px] uppercase tracking-[0.07em] text-white transition-colors duration-150 ease-out hover:bg-fred-dark" data-id="element-156" data-mp="xyh1kjf1xbag">
              Shop All Tools
            </a>
          </nav>

          <button type="button" onClick={() => setMobileOpen(v => !v)} ref={mobileButtonRef} aria-expanded={mobileOpen} aria-controls="mobile-menu" className="flex h-11 w-11 items-center justify-center border border-steel-200 text-charcoal lg:hidden" data-id="element-157" data-mp="jzps5ab4wdsn">
            <span className="sr-only" data-id="element-158" data-mp="19riiproucmw">{mobileOpen ? 'Close menu' : 'Open menu'}</span>
            {mobileOpen ? <XIcon aria-hidden="true" className="h-5 w-5" data-id="element-159" data-mp="3sg2e46dxil6u" /> : <MenuIcon aria-hidden="true" className="h-5 w-5" data-id="element-160" data-mp="3ngzjlfvkrxd4" />}
          </button>
        </div>
      </div>

      {mobileOpen && <div id="mobile-menu" className="border-b border-steel-200 bg-white lg:hidden" data-id="element-161" data-mp="3dsanpwmcu5kj">
          <nav aria-label="Mobile" className="mx-auto max-w-[1240px] px-5 py-4 sm:px-8" data-id="element-162" data-mp="3it8akmib7nsd">
            <a href={LINKS.shopAll} className="mb-4 flex min-h-[48px] items-center justify-center bg-fred px-5 font-display text-[20px] uppercase tracking-[0.07em] text-white" data-id="element-163" data-mp="33vphj7ylmof4">
              Shop All Tools
            </a>
            <p className="mb-2 font-display text-[13px] uppercase tracking-eyebrow text-steel-600" data-id="element-164" data-mp="5dajey9r4bt0">Shop Tools</p>
            <ul className="mb-4 border-t border-steel-100" data-id="element-165" data-mp="3mu1smz92m8dc">
              {SHOP_MENU.slice(0, -1).map(item => <li key={item.name} className="border-b border-steel-100" data-id="element-166" data-mp="3rs3chmebmbpv">
                  <a href={item.href} className="flex min-h-[48px] items-center text-[15px] text-ink" data-id="element-167" data-mp="jdblui5nzral">
                    {item.name}
                  </a>
                </li>)}
            </ul>
            <ul className="border-t border-steel-100" data-id="element-168" data-mp="28tnkymtah0jj">
              {NAV.map(item => <li key={item.name} className="border-b border-steel-100" data-id="element-169" data-mp="23vdng5k3dnur">
                  <a href={item.href} className="flex min-h-[48px] items-center font-display text-[20px] uppercase tracking-[0.04em] text-charcoal" data-id="element-170" data-mp="23t9n1xlej6z8">
                    {item.name}
                  </a>
                </li>)}
            </ul>
            <a href={CONTACT.phoneHref} className="mt-4 flex min-h-[48px] items-center gap-2 font-medium text-charcoal" data-id="element-171" data-mp="1kw87xjy4vqhk">
              <PhoneIcon aria-hidden="true" className="h-4 w-4 text-fred" data-id="element-172" data-mp="1yxc6pra520mg" />
              {CONTACT.phoneLabel}
            </a>
          </nav>
        </div>}
    </header>;
}